(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:DateUtils
     *
     */
    angular
        .module('app')
        .factory('DateUtils', Service);

    /* @ngInject */
    function Service($filter) {

        return {
            convertDateTimeFromServer: convertDateTimeFromServer,
            // TODO: Probar resto de métodos
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date * 1000);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();
